import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import { useForm } from 'react-hook-form';
import { FormField } from 'components';
import { trackEvent } from '../../../utils/dataLayer';
import * as styles from './styles.module.scss';

const Form = ({
  content,
  location,
  prefilledEmail,
  fields,
  removeLabels,
  submitButtonText,
  className,
  onSubmit,
  formId,
}) => {
  const { register, handleSubmit, formState } = useForm({ mode: 'onChange' });

  const [submitting, setSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState(false);

  const { errors, dirtyFields } = formState;

  useEffect(
    () =>
      // Set submitting to false in clean up function
      () => {
        setSubmitting(false);
      },
    []
  );

  const defaultFields = [
    {
      type: 'text',
      name: 'firstName',
      placeholder: 'Pepe',
      label: 'First name',
      className: 'split-left',
      autoFocus: true,
      defaultValue: '',
      validation: { required: true },
      validationMessage: 'Please enter your first name',
    },
    {
      type: 'text',
      name: 'lastName',
      placeholder: 'Silvia',
      label: 'Last name',
      className: 'split-right',
      defaultValue: '',
      validation: { required: true },
      validationMessage: 'Please enter your last name',
    },
    {
      type: 'tel',
      name: 'phone',
      placeholder: '0422 123 456',
      label: 'Best Phone number',
      defaultValue: '',
      validation: { required: true, minLength: 8 },
      validationMessage: 'Please enter a valid number',
    },
    {
      type: 'email',
      name: 'email',
      placeholder: 'carol@hr.com',
      label: 'Email address',
      defaultValue: prefilledEmail || '',
      validation: { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i },
      validationMessage: 'Please enter a valid email',
    },
    {
      type: 'textarea',
      name: 'message',
      placeholder: "What's on your mind?",
      label: 'Enter a message',
      defaultValue: '',
    },
  ];

  const encode = (formData) =>
    Object.keys(formData)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(formData[key])}`)
      .join('&');

  const defaultOnSubmit = async (values) => {
    setSubmitting(true);
    try {
      const url = `https://submit-form.com/${formId}`;
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(values),
      };
      const response = await fetch(url, config);
      // const json = await response.json()
      if (response.ok) {
        if (formId === 'CzWmkbWl') {
          trackEvent(`form_id_${formId}_newsletter_subscription`, {
            user_data: {
              first_name: values.firstName,
              email_address: values.email,
            },
          });
        }

        if (formId === 'SDExXuyD') {
          trackEvent(`form_id_${formId}_contact_us`, {
            user_data: {
              name: values.name,
              email_address: values.email,
            },
          });
        }

        // return json
        return navigate('/thank-you');
      }
    } catch (error) {
      console.error('Error submitting form', error);
      setSubmissionError('Oops something went wrong, please try again');
      setSubmitting(false);
    }
  };

  return (
    <section className={className || ''}>
      {submissionError && <p>{submissionError}</p>}
      <form onSubmit={handleSubmit(onSubmit || defaultOnSubmit)} className={styles.form}>
        <button type="submit" disabled aria-hidden="true" style={{ display: 'none' }} />
        {(fields || defaultFields).map((field) => {
          const hasError = dirtyFields[field.name] && errors[field.name];
          return (
            <div key={field.label} className={`${styles.field} ${field.className || ''}`}>
              {!removeLabels && <span className={styles.label}>{field.label}</span>}
              <FormField {...field} register={register} />
              <div className={`${styles.fieldError} ${hasError ? 'active' : 'inactive'}`}>
                {hasError && <span>{field.validationMessage || 'This field is required'}</span>}
              </div>
            </div>
          );
        })}
        <input
          {...register('_gotcha')}
          type="checkbox"
          name="_gotcha"
          style={{ display: 'none' }}
          tabIndex="-1"
          autoComplete="off"
        />
        <button type="submit" className={`button secondary ${styles.formButton} submit-button`} disabled={submitting}>
          {submitting ? 'Submitting' : submitButtonText || 'Submit'}
        </button>
      </form>
    </section>
  );
};

export default Form;
